/**
 * Locks page scrolling while one or more dialogs are open.
 *
 * Dialogs are teleported to <body>, so without this the page behind them keeps
 * scrolling when the dialog content reaches the end of its own scroll area
 * (scroll chaining), which is especially visible in Safari.
 *
 * `body { overflow: hidden }` alone is ignored by iOS Safari, so the body is
 * fixed in place at the current scroll offset and restored on unlock.
 * Owners are tracked in a Set so nested dialogs don't unlock each other.
 */
const owners = new Set();
let savedScrollY = 0;

export function lockBodyScroll(owner) {
  if (owners.has(owner)) return;
  if (owners.size === 0) {
    savedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    const body = document.body;
    body.style.position = 'fixed';
    body.style.top = `-${savedScrollY}px`;
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';
    body.classList.add('dialog-open');
  }
  owners.add(owner);
}

export function unlockBodyScroll(owner) {
  if (!owners.has(owner)) return;
  owners.delete(owner);
  if (owners.size === 0) {
    const body = document.body;
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.width = '';
    body.style.overflow = '';
    body.classList.remove('dialog-open');
    window.scrollTo(0, savedScrollY);
  }
}
